var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.22 19.133 22.876.793a2.705 2.705 0 0 0-3.826 0l-3.81 3.81 4.832 4.83a3.21 3.21 0 0 1 4.069 4.096l4.656 4.657a3.215 3.215 0 0 1 3.327 5.313 3.22 3.22 0 0 1-5.255-3.501l-4.342-4.342v11.43a3.219 3.219 0 1 1-2.646-.092V15.456a3.213 3.213 0 0 1-1.747-4.219l-4.767-4.766L.793 19.051a2.705 2.705 0 0 0 0 3.826l18.343 18.342a2.705 2.705 0 0 0 3.826 0l18.257-18.254a2.714 2.714 0 0 0 0-3.832Z",
    fill: "#F05133"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.bb725ee67f10e5097233785965803f66.svg";
export { ForwardRef as ReactComponent };